<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Restore {{"Product" | tenantWords}}</h2>
      <div class="modal-subtitle">Bring a removed {{"product" | tenantWords}} back onto this unit</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close(false)">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faRotateLeft" class="section-icon"></fa-icon>
        <h3>Removed {{"Products" | tenantWords}}</h3>
        <span class="count-pill">{{this.details.length}}</span>
      </div>
      <mat-radio-group class="removed-list" [(ngModel)]="this.selectedDetailId" name="removedDetail"
        aria-label="Removed products">
        <mat-radio-button *ngFor="let d of this.details; trackBy: trackByDetail" [value]="d.id" class="removed-option"
          [class.selected]="d.id === this.selectedDetailId">
          <span class="option-text">
            <span class="option-name">{{d.itemName}}</span>
            <span class="option-sub">{{"Lot" | tenantWords}} {{d.lotNumber}}</span>
          </span>
          <span class="option-qty">{{d.quantity | number}}</span>
        </mat-radio-button>
      </mat-radio-group>
    </section>

    <mat-form-field appearance="outline" class="reason-field" *ngIf="this.transactionReasons.length">
      <mat-label>{{"Reason" | tenantWords}}</mat-label>
      <mat-select id="reason" [(ngModel)]="this.transactionReasonCodeId" name="reason">
        <mat-option *ngFor="let re of this.transactionReasons" [value]="re.id">
          {{re.reason}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close(false)">Cancel</button>
    <button mat-raised-button color="primary" type="button" [disabled]="!this.selectedDetailId" (click)="close(true)">
      <fa-icon [icon]="faRotateLeft" class="me-2"></fa-icon>Restore
    </button>
  </div>

</div>
